import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Steps, Tabs } from 'antd';
import TopInfo from '../../basicElement/TopInfo';
import Background from './Background';
import Update from '../Components/Update';
import Params from './Params';
import Detail from './Detail';
import Cover from './Cover';
import ServerContent from './ServerContent';
import Total from './Total';
import Payment from './Payment';
import Sidebar from '../Sidebar';
import format from '../../shared/format';
import ToggleVersion from '../Components/ToggleVersion';
import CustomOpinion from '../Components/CustomOpinion';

const { Step } = Steps;
const { TabPane } = Tabs;

const steps = [{
    title: '封面',
}, {
    title: '公司简介',
}, {
    title: '报价参数',
}, {
    title: '报价明细',
}, {
    title: '服务内容',
}, {
    title: '总价',
}, {
    title: '付款计划',
}];

class Production extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'add',
            current: '0',
            hasEdit: false,
            updateVisible: false,
            panes: [{
                title: '封面',
                key: '0',
                content: this.getContent,
            }, {
                title: '公司简介',
                key: '1',
                content: this.getContent,
            }, {
                title: '报价参数',
                key: '2',
                content: this.getContent,
            }, {
                title: '总价',
                key: '5',
                content: this.getContent,
            }, {
                title: '报价明细',
                key: '3',
                content: this.getContent,
            }, {
                title: '服务内容',
                key: '4',
                content: this.getContent,
            }, {
                title: '付款计划',
                key: '6',
                content: this.getContent,
            }]
        };
    }

    componentDidMount() {
        const { quotationInfo } = this.props;
        if (!Object.keys(quotationInfo).length) {
            location.href = './#/quotation/list';
        }
    }

    hasChange = () => {
        this.setState({ hasEdit: true });
    }

    toggleUpdate = (updateVisible) => {
        this.setState({ updateVisible });
    }

    changeStep = (step) => {
        const { current } = this.state;
        if (step < 0) {
            if (current == 0) {
                this.toggleUpdate(true);
            } else {
                this.setState({
                    hasEdit: false,
                    current: current - 1
                });
            }
        } else {
            if (current == 6) {
                location.href = './#/quotation/list';
            } else {
                this.setState({
                    hasEdit: false,
                    current: Number(current) + 1,
                });
            }
        }
    }

    handleClick = () => {
        const { hasEdit } = this.state;
        if (hasEdit) {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{ marginLeft: 42 }}>是否确认放弃编辑？</div>,
                content: '确认后，本次编辑的内容将被清空',
                onOk: () => {
                    history.go(-1);
                },
            });
        } else {
            history.go(-1);
        }
    }

    getContent = (current) => {
        const { quotationInfo, mode = '', language = 'en' } = this.props;
        const { status } = quotationInfo;
        const height = (document.documentElement || document.body).clientHeight - 120;
        if (current == 0) {
            return <Cover status={status} height={height} mode={mode} language={language} changeStep={this.changeStep} hasChange={this.hasChange} />;
        } else if (current == 1) {
            return <Background status={status} height={height} mode={mode} language={language} changeStep={this.changeStep} hasChange={this.hasChange} />;
        } else if (current == 2) {
            return <Params status={status} height={height} mode={mode} language={language} changeStep={this.changeStep} hasChange={this.hasChange} />;
        } else if (current == 3) {
            return <Detail status={status} height={height} mode={mode} language={language} changeStep={this.changeStep} hasChange={this.hasChange} />;
        } else if (current == 4) {
            return <ServerContent status={status} height={height} mode={mode} language={language} changeStep={this.changeStep} hasChange={this.hasChange} />;
        } else if (current == 5) {
            return <Total status={status} height={height} mode={mode} language={language} changeStep={this.changeStep} hasChange={this.hasChange} />;
        } else if (current == 6) {
            return <Payment status={status} height={height} mode={mode} language={language} changeStep={this.changeStep} hasChange={this.hasChange} />;
        }
    }

    handleTabsChange = (activeKey) => {
        this.setState({ current: activeKey });
    }

    toggleVersion = () => {
        this.versionRef.show();
    }

    toggleVersion = () => {
        this.versionRef.show();
    }

    showOpinion = (record) => {
        this.opinionRef.show(record);
    }

    render() {
        const { quotationInfo } = this.props;
        const { current, updateVisible, panes } = this.state;
        const { quotationNum, salesforceId, version, quotationId, guidePrice, status } = quotationInfo;
        const versions = (
            <div className="topInfo-tag" onClick={this.toggleVersion}>
                <i className="icon iconfont">&#xe674;</i>
                切换版本
            </div>
        );
        const customOpinion = <div className="topInfo-tag" onClick={() => this.showOpinion(quotationInfo)}>客户修改意见</div>;
        const title = quotationId ? (
            <div className="quotation-topInfo">
                报价单号：{quotationNum}
                <span className="ant-divider" />
                Salesforce ID：{salesforceId}
                {
                    (guidePrice || guidePrice === 0) &&
                    <span>
                        <span className="ant-divider" />
                        报价单指导价：{format('money', guidePrice)} 元
                    </span>
                }
                <span className="ant-divider" />
                当前版本：{version}
                {status !== 'add' && versions}
                {status !== 'add' && customOpinion}
            </div>
        ) : '';
        return (
            <div className="full home quotation">
                <TopInfo title={title} style={{marginBottom: 6, padding: '0 10px' }} onClick={this.handleClick} />
                {
                    status === 'add' ?
                        <div>
                            <Steps progressDot current={Number(current)}>
                                {steps.map(item => <Step key={item.title} title={item.title} />)}
                            </Steps>
                            {this.getContent(current)}
                            <Update visible={updateVisible} type="edit" hide={this.toggleUpdate} />
                        </div>
                    :
                        <div>
                            <Tabs type="card" activeKey={current} onChange={this.handleTabsChange}>
                                {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content(pane.key)}</TabPane>)}
                            </Tabs>
                            <Sidebar />
                            <ToggleVersion ref={el => this.versionRef = el} />
                            <CustomOpinion ref={el => this.opinionRef = el} />
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    ...state.quotationState,
});

export default connect(mapStateToProps, null)(Production);


// WEBPACK FOOTER //
// ./src/components/quotation/Production/index.js